
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.5","height":"19.933"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"prefix__Chat","transform":"translate(-.75 44.746)"}},[_c('path',{attrs:{"id":"prefix__Chat-2","d":"M-.894-12.944a.673.673 0 00.221.634.672.672 0 00.441.164.67.67 0 00.217-.036L3.563-13.4a17.442 17.442 0 004.326.689c5.514 0 10-4.008 10-8.935s-4.486-8.936-10-8.936-10 4.009-10 8.936a8.223 8.223 0 001.874 5.21z","data-name":"Chat","transform":"translate(3.612 -13.418)","stroke-linecap":"round","stroke-linejoin":"round","fill":"none","stroke-width":"1.5"}}),_c('path',{attrs:{"id":"prefix__Dot","d":"M-1.6-.8a.766.766 0 01-.766.766.766.766 0 01-.767-.766.766.766 0 01.766-.766A.766.766 0 01-1.6-.8","transform":"translate(9.945 -34.172)","fill":"#fff","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"prefix__cls-3",attrs:{"id":"prefix__Dot-2","d":"M-1.6-.8a.766.766 0 01-.766.766.766.766 0 01-.767-.766.766.766 0 01.766-.766A.766.766 0 01-1.6-.8","data-name":"Dot","transform":"translate(13.765 -34.172)","fill":"#fff","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"prefix__cls-3",attrs:{"id":"prefix__Dot-3","d":"M-1.6-.8a.766.766 0 01-.766.766.766.766 0 01-.767-.766.766.766 0 01.766-.766A.766.766 0 01-1.6-.8","data-name":"Dot","transform":"translate(17.586 -34.172)","fill":"#fff","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    